// workaround for current MVision Configuration TypeScript version not including AbortSignal.timeout
type AbortSignalWithTimeout = AbortSignal & { timeout(milliseconds: number): AbortSignal }

/** Workaround for current MVision Configuration TypeScript version not including AbortSignal.timeout. */
export const timeoutSignal = (timeoutInMs: number) => (AbortSignal as unknown as AbortSignalWithTimeout).timeout(timeoutInMs);
